import 'bootstrap';
import _ from 'underscore';
import AlertListView from '../alert-list/index';
import type {
  I18nModel,
  IAlertListViewOptions,
} from '../types';
import template from './template.pug';

interface AlertCarouselRuntimeFields {
  carouselId: string;
  i18n: I18nModel | undefined;
}

/**
 * Represents a carousel as a list of alerts
 */
export default class AlertCarouselView extends AlertListView {
  initialize({ level, i18n }: IAlertListViewOptions) {
    const view = this as this & AlertCarouselRuntimeFields;
    view.i18n = i18n;
    view.carouselId = _.uniqueId('alert-carousel-');
    super.initialize({ level });
  }

  get template() {
    return template;
  }
}
